import { formatUnits, parseUnits } from 'ethers/lib/utils';
import { UserPositionRaw } from '../../hooks/web3/trade/useUserPositions';
import { toBigNumber } from '../../web3/utils';
import { config } from '../../config/config';

export type PnlValues = {
    pnlGross: string;
    pnlGrossPercent: string;
    pnl: string;
    pnlPercent: string;
    pnlFeePercent: string;
};

const calculatePnl = (
    position: UserPositionRaw | undefined,
    price: string | undefined
): PnlValues | undefined => {
    if (!position || !price) return;

    const decimals = config.priceFeedDecimal;

    const entryPrice = parseUnits(position?.entryPrice || '0', decimals).isZero()
        ? toBigNumber(price, decimals)
        : parseUnits(position?.entryPrice || '0', decimals);

    const pnlGross = toBigNumber(price, decimals)
        .sub(entryPrice)
        .mul(position?.isShort ? -1 : 1)
        .mul(parseUnits('1', decimals))
        .div(entryPrice)
        .mul(parseUnits(position?.volume || '1', decimals))
        .div(parseUnits('1', decimals));

    const pnl = pnlGross.sub(parseUnits(position.totalFeeAmount, decimals));

    const entryMargin = parseUnits(position.entryMargin).gt(0)
        ? parseUnits(position.entryMargin, decimals)
        : parseUnits('1', decimals);

    return {
        pnlGross: formatUnits(pnlGross, decimals),
        pnlGrossPercent: formatUnits(
            pnlGross.mul(parseUnits('100', decimals)).div(entryMargin),
            decimals
        ),
        pnl: formatUnits(pnl, decimals),
        pnlPercent: formatUnits(
            pnl.mul(parseUnits('100', decimals)).div(entryMargin),
            decimals
        ),
        pnlFeePercent: formatUnits(
            parseUnits(position.totalFeeAmount, decimals)
                .mul(parseUnits('100', decimals))
                .div(entryMargin),
            decimals
        ),
    };
};

export default calculatePnl;
